import { render, staticRenderFns } from "./UpdateCard.vue?vue&type=template&id=663977e8&scoped=true"
import script from "./UpdateCard.vue?vue&type=script&lang=js"
export * from "./UpdateCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663977e8",
  null
  
)

export default component.exports